export const vdmDashboardConstants = {
	FEATURE: "@vdmdashboard",
};
